export const shareArticle = async (e, article) => {
  // Prevent the click from bubbling up to the <a> tag and opening the article
  e.preventDefault();
  e.stopPropagation();

  const shareData = {
    title: article.title,
    text: article.summary ? `${article.summary.substring(0, 100)}...` : 'Check out this article on Sulit.ph',
    url: article.link,
  };

  // Try using the native Web Share API (Works great on iOS, Android, and modern desktop browsers)
  if (navigator.share) {
    try {
      await navigator.share(shareData);
    } catch (error) {
      // User might have canceled the share dialog, which is normal.
      console.log('Share canceled or failed:', error);
    }
  } else {
    // Fallback for browsers that don't support native sharing (e.g., older Chrome on Desktop)
    try {
      await navigator.clipboard.writeText(article.link);
      alert('Article link copied to clipboard!');
    } catch (err) {
      console.error('Failed to copy text: ', err);
    }
  }
};